import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useStore, useTitle } from '../../core/utils/hook';
import { getGeneralSettingValueByType } from './utils/GeneralSetting.utils';
import ReactHtmlParser from 'react-html-parser';
import { useEffect } from 'react';



const GeneralSettingScreen = observer(({ pageTitle, type }) => {
    // store
    const {
        generalSettingStore: { getGeneralSettingByType }
    } = useStore();
    const [value, setValue] = useState('');
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);


    useTitle(pageTitle);

    React.useEffect(() => {
        fetchData();
    }, [type]);

    const fetchData = async () => {
        try {
            const res = await getGeneralSettingByType(type);
            const value = getGeneralSettingValueByType(res, type);
            setValue(value);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div id="main" className="wrapper main-general-setting">
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className="container">
                    <ul>
                        <li>
                            <a href="/">
                                <img src="/images/icon-home.png" alt="" />
                            </a>
                        </li>
                        <li className="dash">\</li>
                        <li>{pageTitle}</li>
                    </ul>
                </div>
            </div>
            <div className="content-Message-detail">
                <div className="container">
                    <h1 className="title-primary">{pageTitle}</h1>

                    <div className="content-content main-general-setting-content pre-wrap">{ReactHtmlParser(value)}</div>
                </div>
            </div>
        </div>
    );
});

export default GeneralSettingScreen;
